
let offerEnd; 
let $this;
	$('.timer').each(function() {
		offerEnd = $(this).attr('offer-end');
		$this = $(this).index();
		function makeTimer() {
			//		var endTime = new Date("29 April 2018 9:56:00 GMT+01:00");	
		
			var endTime = new Date(offerEnd)			
				endTime = (Date.parse(endTime) / 1000);
	
				var now = new Date();
				now = (Date.parse(now) / 1000);
	
				var timeLeft = endTime - now;
	
				var days = Math.floor(timeLeft / 86400); 
				var hours = Math.floor((timeLeft - (days * 86400)) / 3600);
				var minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600 )) / 60);
				var seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));
	  
				if (hours < "10") { hours = "0" + hours; }
				if (minutes < "10") { minutes = "0" + minutes; }
				if (seconds < "10") { seconds = "0" + seconds; }
	
				$(".timer").eq($this).find(".days").html(days + "<span class='timer-unit'>Days</span>");
				$(".timer").eq($this).find(".hours").html(hours + "<span class='timer-unit'>HRS</span>");
				$(".timer").eq($this).find(".minutes").html(minutes + "<span class='timer-unit'>MIN</span>");
				$(".timer").eq($this).find(".seconds").html(seconds + "<span class='timer-unit'>SEC</span>");	



				if(endTime < now) {
					console.log("yes")
				}	
	
			}
		
		setInterval(function() { makeTimer(); }, 1000);
	
	})



$('body').on('click', '.js-delete-cart-item', function() {
	var $emptyCart = `<div class="emty-card">
    <div class="d-flex flex-column align-items-center justify-content-center"><img class="img-fluid" src="./img/cart/empty-cart.svg" /><span class="text-333 text-16 ml-md-4 mt-2">Empty Cart!</span></div>
</div>`

	$(this).parents('.cart-selected-item').find('.cart-selected-item__info').append($emptyCart);

	$(this).parents('.summary-card').remove();

	$('.cart-nav').find('.cart-pay button').prop('diabled', true);
	$('.cart-nav').find('.cart-pay').hide();
	$('.cart-nav').find('.cart-shoping').removeClass('d-none');
	$('.cart-nav').find('.cart-shoping button').prop('diabled', false);
	$('.cart-nav').find('.cart-shoping').show();
})